const $body = $('body');

// menu-toggle
$('[data-toggle="menu"]').on('click', function (e) {
    e.preventDefault();

    if ($body.hasClass('show-menu')) {
        $body.removeClass('show-menu');
    } else {
        $body.addClass('show-menu');
    }
});

// actions on key press
$(document).keyup(function(e) {
    if (e.key === "Escape") {
        $body.removeClass('show-menu');
    }
});
